import { format } from "date-fns";
import { OrderFormElementType, OrderGroup, OrderStatus } from "enums";

const LAB_RAD_CONTRAST_ELEMENT_TYPES: OrderFormElementType[] = [
  "Lab",
  "Radiology",
  "Contrast",
];

const LAB_RAD_CONTRAST_CANCEL_BLOCKED_STATUSES: OrderStatus[] = [
  "Completed",
  "CancellationRequested",
  "Cancelled",
];

function getOrderDetailsDateFormat(date?: Date | null) {
  if (!date) {
    return "";
  }

  return `${format(date, "MMM dd, yyyy")} at \n ${format(date, "h:mm a")}`;
}

function getOrderDetailsDateShortFormat(date?: Date | null) {
  if (!date) {
    return "";
  }

  return format(new Date(date), "MM/dd/yy h:mm a");
}

function getValueByOrderGroup<T>(
  labsValue: T,
  radiologyValue: T
): Record<OrderGroup, T> {
  return {
    Labs: labsValue,
    Radiology: radiologyValue,
  };
}

function isLabRadContrastElementType(elementType: OrderFormElementType) {
  return LAB_RAD_CONTRAST_ELEMENT_TYPES.includes(elementType);
}

function isLabRadContrastCompleted(
  elementType: OrderFormElementType,
  status: OrderStatus
) {
  return isLabRadContrastElementType(elementType) && status === "Completed";
}

function isLabRadContrastCancelBlocked(
  elementType: OrderFormElementType,
  status: OrderStatus
) {
  return (
    isLabRadContrastElementType(elementType) &&
    LAB_RAD_CONTRAST_CANCEL_BLOCKED_STATUSES.includes(status)
  );
}

export {
  getOrderDetailsDateFormat,
  getOrderDetailsDateShortFormat,
  getValueByOrderGroup,
  isLabRadContrastCancelBlocked,
  isLabRadContrastCompleted,
  isLabRadContrastElementType,
};
